export const DOCSubscriptionFormName = 'doc-subscription';

export enum DOCSubscriptionFormFields {
  PackageOptions = 'packageOptions',
}
